import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Chrome wrapper for editable line-item / "add item" tables (Custom
 * Information, Add Products, …). It standardises the rounded bordered frame,
 * a horizontal-scroll affordance (scrolling shadows so users can tell the
 * table scrolls when columns overflow), an invalid border state, and an
 * Add-Item footer — so every form's entry table looks and behaves the same.
 *
 * The consuming form projects its own `<table>` (with its bespoke columns,
 * controls and validation) as default content; the table internals stay owned
 * by the form. Footer buttons are projected via the `ancEntryGridFooter` slot.
 *
 * @example
 * <lib-anc-entry-grid [invalid]="invalidSku">
 *   <table class="table"> ...thead / rows / entry-row... </table>
 *   <div ancEntryGridFooter>
 *     <button class="add-item-btn" (click)="addProduct()">Add Item</button>
 *   </div>
 * </lib-anc-entry-grid>
 */
@Component({
    selector: 'lib-anc-entry-grid',
    imports: [CommonModule],
    templateUrl: './anc-entry-grid.component.html',
    styleUrls: ['./anc-entry-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncEntryGridComponent {
    /** Red frame when the table as a whole is invalid (e.g. SKU mismatch). */
    invalid = input<boolean>(false);
    /** Min-height of the scroll area; keeps short tables from collapsing. */
    minHeight = input<string>('120px');
}
